import { Permissions } from "#root/shared/enums/permission.enum";
import NavBarByPermission from "#utils/nav-role/nav-by-permissions";
/* tslint:disable:max-line-length */

export default function defaultNavigation() {
  let userPermissions: Permissions[];
  const userPermissionsData = localStorage.getItem("permissions");
  if (userPermissionsData) {
    userPermissions = JSON.parse(userPermissionsData);
  }

  return NavBarByPermission(userPermissions);
}
